import TextEditorCustomize from '@/components/TextEditorCustomize'
import { Controller, Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
interface Props {
    control: Control<any>
    viewOnly?: boolean
    maxHeight?: boolean
}

const TicketAffected: React.FC<Props> = ({
    control,
    viewOnly = false,
    maxHeight,
}) => {
    const { t } = useTranslation()

    return (
        <div className={`${maxHeight ? 'h-full flex flex-col' : 'mt-4'}`}>
            <Typogaphy size="small" className="mb-1">
                {t('ticket-affected')}
            </Typogaphy>
            <Controller
                control={control}
                name="ticket_affected"
                render={({ field }) => (
                    <TextEditorCustomize
                        disabled={viewOnly}
                        value={
                            typeof field.value === 'string'
                                ? { text: field.value, attachments: [] }
                                : field.value || { text: '', attachments: [] }
                        }
                        onChange={(val) => field.onChange(val)}
                        imagePrefix="tickets"
                    />
                )}
            />
        </div>
    )
}

export default TicketAffected
